import useAuthStore from 'stores/authStore';

/**
 * Display-only role flags for the active tenant.
 *
 * These gate what the UI *shows*, never what the user *may do*: every mutation
 * is re-authorized server-side against the live TenantMembership row
 * (tenants/permissions.py).
 */
export default function useRole() {
  const activeMembership = useAuthStore((s) => s.activeMembership);
  const role = activeMembership?.role ?? null;
  return {
    role,
    isOwner: role === 'owner',
    isAdmin: role === 'owner' || role === 'admin',
  };
}
